import React from 'react';
import faxriddin from '../Images/Faxriddin.png';


const Baxtiyor = () => {
    return (
        <div style={{color: 'black'}}>
            <div className='container text-start'>
                <div className='row'>
                    <div className='col-10'>
                        <h1 className='text-center'>МАЪЛУМОТНОМА</h1>
                        <h2 className='text-center'>Юсупов Фахриддин Бахтиёрович</h2>
                        <p>2021 йил 6 февралдан:</p>
                        <p>Чилонзор туман 2-сон касб-ҳунар мактабининг - Директорнинг ёшлар билан ишлаш бўйича ўринбосари</p>
                    </div>   
                    <div className='col-2'>
                        <img src={faxriddin} />
                    </div>    
                </div> 
                <div className='row'>
                    <div className='col'>
                        <p className='h5'>Туғилган йили:</p>
                        <p>10.06.1977</p>
                        <p className='h5'>Миллати:</p>
                        <p>ўзбек</p>
                        <p className='h5'>Маълумоти:</p>
                        <p>олий</p>
                        <p className='h5'>Маълумоти бўйича мутахассислиги:</p>
                        <p className='h5'>Илмий даражаси:</p>
                        <p>йўқ</p>
                        <p className='h5'>Қайси чет тилларини билади:</p>
                        <p>рус тили</p>
                        <p className='h5'>Давлат мукофотлари билан тақдирланганми (қанақа):</p>
                        <p>йўқ</p>
                        <p className='h5'>Халқ депутатлари, республика, вилоят, шаҳар ва туман Кенгаши депутатими ёки бошқа
сайланадиган органларнинг аъзосими (тўлиқ кўрсатилиши лозим)	</p>
                        <p>йўқ</p>
                    </div>
                    <div className='col'>
                    <p className='h5'>Туғилган жойи:</p>
                        <p>Самарқанд вилояти, Нарпай тумани</p>
                        <p className='h5'>Партиявийлиги:</p>
                        <p>йўқ</p>
                        <p className='h5'>Тамомлаган:</p>
                        <p>2014 й. Тошкент молия институти (кундузги)</p>
                        <p>суғурта иши, банк иши</p>
                        <p className='h5'>Илмий унвони:</p>
                        <p>йўқ</p>
                        <p className='h5'>Ҳарбий (махсус) унвони:</p>
                        <p>йўқ</p>
                    </div>
                </div>
                <p className='h3'>МЕҲНАТ ФАОЛИЯТИ</p>
                <p>1994-2002 йй. - Самарқанд вилояти Нарпай тумани "Ўзбекистон" жамоа ширкат хўжалигининг - ҳисобчи</p>
                <p>1999-2002 йй. - Тошкент банк коллежи Сиртқи бўлимининг - талаба</p>
                <p>2002-2003 йй. - Тошкент банк ҳисоб-кредит коллежининг - молиявий ва хўжалик таъминотчиси</p>
                <p>2003-2010 йй. - Тошкент банк ҳисоб-кредит коллежининг - коменданти</p>
                <p>2006-2010 йй. - Тошкент молия институти Сиртқи бўлимининг - талаба</p>
                <p>2010-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - Бўлим бошлиғи</p>
                <p>2020-2021 йй. - Чилонзор туман 2-сон касб-ҳунар мактабининг - Ўқув - методик бўлими бошлиғи</p>
                <p>2021 й. -  ҳ.в.  - Чилонзор туман 2-сон касб-ҳунар мактабининг - Директорнинг ёшлар билан ишлаш бўйича ўринбосари</p>
                    <br />
                <p className='h2'>Малумотнома паспорт, диплом ва меҳнат дафтарчасига асосан тўғри ёзилган</p>
                <div className='row'>
                    <div className='col'>
                        <p className='h4'>КҲМ директори:</p>
                        <p className='h4'>Кадрлар бўйича инспектори:</p>
                    </div>
                    <div className='col'>
                        <p className='h4'>  Б.И.Тўйинов</p>
                        <p className='h4'>  Ш.А.Райимқулов  </p>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Baxtiyor;